import { IActionResult } from '../types/IActionResult';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateConnectionsParams {
  ids: string[];       // Data source ids
  server?: string;
  port?: string;
  username?: string;
  embedPassword?: boolean;
  encryptedPassword?: string;
  encryptedPasswordKeyId?: string;
  usingRemoteQueryAgent?: boolean;
}

export class UpdateConnectionsRequest extends Request<IUpdateConnectionsParams, IActionResult> {
  constructor(params: IUpdateConnectionsParams) {
    super('updateConnections', params);
  }
}
